import { render, staticRenderFns } from "./PolizasPorRenovar.vue?vue&type=template&id=00d25498"
import script from "./PolizasPorRenovar.vue?vue&type=script&lang=js"
export * from "./PolizasPorRenovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports